
<template>

	<mymodal ref="modal" title="Импорт" ok="Импортировать" :reset="reset" :check="check" :submit="submit" :ok_hide="false">

		<b-overlay :show="wait">

			<b-form-group :state="fl_state" label="Файл" label-for="fl_input" invalid-feedback="Необходимо указать файл">
				
				<b-form-file id="fl_input" :state="fl_state" v-model="fl" placeholder="Файл" v-on:change="load_file" accept=".xlsx"/>

			</b-form-group>

			<b-form-group :state="sheet_state" label="Страница" label-for="sheet_select" invalid-feedback="Необходимо указать страницу">

				<v-select id="sheet_select" :state="sheet_state" :clearable="false" v-model="sheet" :options="wb.SheetNames" v-on:input="sheet_select" clearSearchOnSelect required appendToBody/>

			</b-form-group>

			<b-form-group :state="key_state" :label="wear_attr.label" invalid-feedback="Необходимо указать столбец">

				<v-select :state="key_state" :clearable="false" v-model="key" label="name" :options="attrs" :reduce="obj => obj.id" v-on:input="() => check()" clearSearchOnSelect required appendToBody/>

			</b-form-group>

			<b-form-group :state="value_state" label="Устаревание" invalid-feedback="Необходимо указать столбец">

				<v-select :state="value_state" :clearable="false" v-model="value" label="name" :options="attrs" :reduce="obj => obj.id" v-on:input="() => check()" clearSearchOnSelect required appendToBody/>

			</b-form-group>

		</b-overlay>

	</mymodal>

</template>

<script>

import XLSX from "xlsx"
import api from "../../../../../../api"
import mymodal from "../../../../../widgets/modal"

export default
{
	props :
	{
		id : String,
	},

	components :
	{
		mymodal,
	},

	data()
	{
		return {

			service : "cadastral_cost_evaluation",

			fl : null,
			fl_state : null,

			wb : { sheets : [] },

			attrs : [],

			sheet : null,
			sheet_state : null,

			key : null,
			key_state: null,

			value : null,
			value_state: null,

			wear_attr : "",
			is_external : null,

			wait : false,

		}
	},

	methods :
	{
        check_roles(roles)
        {
            return api.check_roles(this, roles)
        },
		
		reset()
		{
			this.fl = null
			this.fl_state = null
			this.sheet = null
			this.sheet_state = null
			this.key = null
			this.key_state = null
			this.value = null
			this.value_state = null
			this.wait = false

			this.check()
		},

		check()
		{
			this.fl_state = !! this.fl
			this.sheet_state = !! this.sheet
			this.key_state = !! this.key
			this.value_state = !! this.value

			return this.fl_state && this.sheet_state && this.key_state && this.value_state
		},

		execute(wear_attr, is_external)
		{
			this.wear_attr = wear_attr
			this.is_external = is_external

			this.check()

			this.$refs.modal.execute()
		},

		load_file(event)
		{
			if(event.target.files)
			{
				const reader = new FileReader()
			
				reader.onload =
					event =>
					{
						const raw = event.target.result
						
						this.wb = XLSX.read(raw, { type : "binary", sheetRows : 30 })

						this.sheet = null
						this.sheet_state = null
						this.key = null
						this.key_state = null
						this.value = null
						this.value_state = null
						this.attrs = []

						if(this.wb.SheetNames.length)
							this.sheet_select(this.wb.SheetNames[0])

						this.wait = false
					}

				this.wait = true
				reader.readAsBinaryString(event.target.files[0])
			}
		},

		sheet_select(sheet)
		{
			this.sheet = sheet

			var attrs = []

			const ws = this.wb.Sheets[this.sheet]
			const range = XLSX.utils.decode_range(ws["!ref"])

			for(var col = range.s.c; col <= range.e.c; col++)
			{
				var cell = ws[XLSX.utils.encode_cell({ c : col, r : 0 })]

				if(cell)
					attrs.push({ name : cell.v, id : col + 1 })
			}

			this.attrs = attrs
		},

		submit()
		{
			const reader = new FileReader()

			if (this.check_roles([ 'model' ]) && !this.not_editable)
			{
				reader.onload =
					fl =>
						api.upload_file(this, fl, this.fl.name, this.fl.name,
							response =>
							{
								var params = {
	
									id : this.id,
									fl : response.id,
									sheet : this.sheet,
									is_external : this.is_external,
									wear_attr : this.wear_attr.key,
									key : this.key,
									value : this.value,
	
								}
	
								this.wait = false
	
								api.call(this, this.service, "import_wear", params,
									response =>
									{
										api.delete_file(this, params.file)
										api.open_response_url(response)
	
										this.$emit("need_refresh")
									})
	
								this.$refs.modal.my_hide()
							})
			}
			else
			{
				this.$refs.modal.my_hide()
			}
					
			this.wait = true
			reader.readAsBinaryString(this.fl)
		}
	}
}

</script>

